$.TemplateSupportDownloads = {
    ResetModules: () => {
        const resultsContainer = $("#support-downloads-product-list-result");
        resultsContainer.empty();
        resultsContainer.removeClass("d-block").addClass("d-none");

        const noRecordsFoundDisplay = $(
            "#support-downloads-product-list-no-records",
        );
        noRecordsFoundDisplay.removeClass("d-block").addClass("d-none");
    },

    SearchProduct: (language) => {
        $.TemplateSupportDownloads.ResetModules();

        const noRecordsFoundDisplay = $(
            "#support-downloads-product-list-no-records",
        );
        const resultsContainer = $("#support-downloads-product-list-result");
        const searchVal = $("#support-downloads-search-input").val();
        $.Backend.SearchProduct(searchVal, language, false).then(
            function (response) {
                const data = response.data;
                if (data.products.length === 1) {
                    $.TemplateSupportDownloads.ShowProduct(
                        data.products[0].partNumber,
                    );
                } else if (data.products.length > 0) {
                    for (let product of data.products)
                        resultsContainer.append(
                            `<a href="javascript:$.TemplateSupportDownloads.ShowProduct(${product.partNumber})" class="list-group-item list-group-item-action">${
                                product.name
                            } (${product.partNumber})</a>`,
                        );
                    resultsContainer.removeClass("d-none").addClass("d-block");
                } else
                    noRecordsFoundDisplay
                        .removeClass("d-none")
                        .addClass("d-block");
            },
        );
    },

    ShowProduct: (partNumber) => {
        $.TemplateSupportDownloads.ResetModules();

        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set("pn", partNumber);
        window.location.search = urlParams.toString();
    },
};

$(document).ready(function () {
    $("#support-downloads-search-input").on("keypress", function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
            $("#support-downloads-search-btn").click();
        }
    });
});
